<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4" sm="12">
        <v-card>
          <base-img :src="profileImage" alt="Profile avatar" class="mx-auto"></base-img>
          <v-card-title primary class="text-center">
            <h2>{{ profileName }}</h2>
          </v-card-title>
          <v-card-subtitle>
            <h3>{{ profileSubtitle }}</h3>
          </v-card-subtitle>
          <v-card-text>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="8" sm="12">
        <v-card flat>
          <v-card-title><h2>{{talkTitle}}</h2></v-card-title>
          <v-card-text><strong>Abstract: </strong>{{abstract}}</v-card-text>
          <v-card-text><strong>Bio: </strong>{{ bio }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    profileImage: {
      type: String,
    },
    profileName: {
      type: String,
      required: true,
    },
    profileSubtitle: {
      type: String,
      required: true,
    },
    talkTitle: {
      type: String,
      required: true,
    },
    abstract: {
      type: String,
      default: "TBA",
    },
    bio: {
      type: String,
      default: "TBA",
    },
  },
};
</script>
